import React from 'react';
import Route from 'found/lib/Route';
import LeadCaptureContainer from '../components/Leads/LeadCaptureContainer';
import KioskContainer from '../components/Leads/KioskContainer';
import LinkContainer from '../components/Leads/LinkContainer';
import EmbedContainer from '../components/Leads/EmbedContainer';
import { Loader } from '../components/Elements';
import ViewerQuery from './ViewerQuery';

const LeadRoutes = (
  <Route path='leads'>
    <Route
      Component={LeadCaptureContainer}
      query={ViewerQuery}
      render={({ props }) => (props ? <LeadCaptureContainer {...props} /> : <Loader />)}
    />
    <Route
      path='embed'
      Component={EmbedContainer}
      query={ViewerQuery}
      render={({ props }) => (props ? <EmbedContainer {...props} /> : <Loader />)}
    />
    <Route
      path='kiosk'
      Component={KioskContainer}
      query={ViewerQuery}
      render={({ props }) => (props ? <KioskContainer {...props} /> : <Loader />)}
    />
    <Route
      path='link'
      Component={LinkContainer}
      query={ViewerQuery}
      render={({ props }) => (props ? <LinkContainer {...props} /> : <Loader />)}
    />
  </Route>
);

export default LeadRoutes;



// WEBPACK FOOTER //
// ./webpack/routes/LeadRoutes.js